<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
<!-- Begin Page Content -->
<div class="container-fluid">
  <!-- Page Heading -->

  <!-- DataTales Example -->
  <div>
    <!-- <div class="card-header py-3">
            <h1 class="text-gray-800" style="display: inline-block">Manage Opdata</h1>
            <button
                type="button"
                class="btn btn-primary"
                style="float: right"
                [routerLink]="['/component', 'opdata', 'opdata-add']"
            >
                Add Opdata
            </button>
        </div> -->
    <div class="row" style="margin-top: 10px">
      <!-- <div style="height: 15px"></div> -->
      <div class="col-12 d-flex align-items-center">
        <!-- <div *ngIf="!showdivplant" class="d-flex align-items-center"> -->

        <!-- Commented on 20th april 2026 for breadcrumbs changes -->
        <!-- <div class="d-flex align-items-center">
          <label for="name" class="form-label">Plant:</label>
          <select
            class="form-select border border-dark"
            name="plantid"
            style="width: 350px; margin-left: 17px"
            (change)="gettrainsbyplantId($event)"
          >
            <option selected>Select Plant</option>
            <option
              *ngFor="let plant of plants"
              [value]="plant.Id"
              [selected]="plant.Id === convertedPlantId"
            >
              {{ plant.Name }}
            </option>
          </select>
          <label for="train" class="form-label" style="margin-left: 15px"
            >Train:</label
          >
          <select
            class="form-select border border-dark"
            name="trainid"
            style="width: 350px; margin-left: 15px; margin-right: 15px"
            (change)="getSelectedId($event)"
          >
            <option selected>Select Train</option>
            <option
              *ngFor="let train of allTrainList"
              [value]="train.Id"
              [selected]="train.Id === ConvertedtrainId"
            >
              {{ train.Name }}
            </option>
          </select>
        </div> -->



        <!-- <div *ngIf="showDvUnit" class="d-flex align-items-center">
                <label for="unit" class="form-label" style="margin-right: 25px;">Unit:</label>
                <select class="form-select border border-dark" name="unitid" disabled>
                  <option
                    *ngFor="let unit of units"
                    [value]="unit.Id"
                    style="width: 350px;"
                    [selected]="unit.Id === trainDetails.Units"
                  >
                    {{ unit.UnitName }}
                  </option>
                </select>
              </div> -->
      </div>
      <!-- <div style="height: 15px"></div> -->
    </div>




    <!-- <div class="row" *ngIf="showDvUnit">
      <div class="col-12 d-flex align-items-center">
        <label for="unit" class="form-label" style="margin-right: 25px"
          >Unit:</label
        >
        <select
          class="form-select border border-dark"
          name="unitid"
          style="width: 200px"
          disabled
        >
          <option
            *ngFor="let unit of units"
            [value]="unit.Id"
            [selected]="unit.Id === trainDetails.Units"
          >
            {{ unit.UnitName }}
          </option>
        </select>
      </div>
    </div> -->

    <div class="col-12" style="margin-top: 7px" *ngIf="showDownload">
      <div class="d-flex align-items-center flex-wrap gap-2">
        <div class="d-flex align-items-center">
          <label class="text-muted mb-0 me-1">Rows</label>
          <select [(ngModel)]="queryParam.PageSize" (change)="onPageSizeChange()" id="PageSize" class="form-select" style="width: auto;">
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </select>
        </div>

        <div class="d-flex align-items-center ms-3">
          <label class="text-muted mb-0 me-1">View:</label>
          <div class="btn-group">
            <button class="btn stage-selector" (click)="showCalc()" [class.active]="showTableCalc">Calculated</button>
            <button class="btn stage-selector" (click)="showRaw()" [class.active]="showTable">Raw</button>
          </div>
        </div>

        <div class="d-flex align-items-center ms-3">
          <label class="text-muted mb-0 me-1">Stage:</label>
          <div class="btn-group">
            <button *ngIf="trainDetails.Stages >= 1" 
                    class="btn stage-selector" (click)="showstageone()" [class.active]="!stages1">1</button>
            <button *ngIf="trainDetails.Stages >= 2" 
                    class="btn stage-selector" (click)="showstagetwo()" [class.active]="!stages2">2</button>
            <button *ngIf="trainDetails.Stages >= 3" 
                    class="btn stage-selector" (click)="showstagethree()" [class.active]="!stages3">3</button>
            <button *ngIf="trainDetails.Stages >= 2" 
                    class="btn stage-selector" (click)="showstagetotal()" [class.active]="!total">Total</button>
          </div>
        </div>

        <button class="btn custom-buttons" (click)="downloadexport(trainDetails.Id)">Download Export</button>
        <button class="btn custom-buttons" [routerLink]="['/component', 'opdata', 'opdata-add']">Add Opdata</button>
        
        <button class="btn custom-delete-btn" (click)="softdelete()" *ngIf="OpdataIds.length > 0">
          Delete Selected Data
        </button>
        
        <button type="button" class="btn custom-buttons" (click)="Undo()" *ngIf="this.opdataWithFlagD.length > 0 || this.opdataWithFlagI.length > 0">
          Undo
        </button>

        <div class="ms-auto d-flex">
          <div class="input-group" style="width: 250px;">
            <input type="text" class="form-control" [(ngModel)]="queryParam.SearchQuery" id="searchQuery" placeholder="Search" />
            <button class="btn btn-outline-dark" (click)="searchtable()"><i class="fa fa-search"></i></button>
          </div>
        </div>
      </div>
    </div>

    <div style="min-height: 20px"></div>

    <div id="dvRaw">
      <div class="table-responsive">

        <table class="table table-bordered" width="100%" *ngIf="opdata && opdataList.length > 0">
          <thead *ngIf="trainDetails.Units == 0">
            <tr>
              <th>
                <!-- <button
                  type="button"
                  class="fa fa-trash-o"
                  (click)="softdelete()"
                ></button> -->
                <input type="checkbox" class="custom-checkbox" [(ngModel)]="masterSelected"
                  (change)="selectAllRows()" />
              </th>
              <th>
                Date
                <i (click)="onSortClick($event, 'Datetime')" class="my-icon fa fa-chevron-up"></i>
              </th>
              <th>
                Time
                <i (click)="onSortClick($event, 'Datetime')" class="my-icon fa fa-chevron-up"></i>
              </th>
              <th>pH</th>
              <th>Temp(&deg;C)</th>
              <th>Concentrate Flow (m3/hr)</th>
              <th>Permeate Flow (m3/hr)</th>
              <th>Feed Pressure (bar)</th>
              <th>Concentrate Pressure (bar)</th>
              <th>Permeate Pressure (bar)</th>
              <th>Feed Conductivity (µS/cm)</th>
              <th>Permeate Conductivity (µS/cm)</th>
            </tr>
          </thead>
          <thead *ngIf="trainDetails.Units != 0">
            <tr>
              <th>
                <!-- <button
                  type="button"
                  class="fa fa-trash-o"
                  (click)="softdelete()"
                ></button> -->
                <input type="checkbox" class="custom-checkbox" [(ngModel)]="masterSelected"
                  (change)="selectAllRows()" />
              </th>
              <th>
                Date
                <i (click)="onSortClick($event, 'Datetime')" class="my-icon fa fa-chevron-up"></i>
              </th>
              <th>
                Time
                <i (click)="onSortClick($event, 'Datetime')" class="my-icon fa fa-chevron-up"></i>
              </th>
              <th>pH</th>
              <th>Temp(&deg;C)</th>
              <th>Concentrate Flow (gpm)</th>
              <th>Permeate Flow (gpm)</th>
              <th>Feed Pressure (psi)</th>
              <th>Concentrate Pressure (psi)</th>
              <th>Permeate Pressure (psi)</th>
              <th>Feed Conductivity (µS/cm)</th>
              <th>Permeate Conductivity (µS/cm)</th>
            </tr>
          </thead>

          <tbody [hidden]="stages1">
            <tr *ngFor="
                let opdata of opdataList
                  | paginate
                    : {
                        itemsPerPage: safePageSize(pageHeaders?.PageSize),
                        currentPage: safePageNumber(pageHeaders?.PageNumber),
                        totalItems: safeTotalItems(pageHeaders?.TotalItems)
                      }
              ">
              <td>
                <!-- <input
                  type="checkbox"
                  id="NouserSelected"
                  name="NouserSelected"
                  (change)="selectednoOtherUser(opdata.Id)"
                /> -->
                <input type="checkbox" class="custom-checkbox" [checked]="isRowSelected(opdata.Id)"
                  (change)="selectednoOtherUser(opdata.Id)" />
              </td>
              <td style="text-wrap: nowrap">
                <a class="text-black" (click)="navigate(opdata.Id)">
                  {{ opdata.Datetime | date : "yyyy-MM-dd" }}</a>
              </td>
              <td>
                <a class="text-black">{{
                  opdata.Datetime | date : "HH:mm:ss"
                  }}</a>
              </td>

              <td width="10%">
                <a class="text-black">{{ opdata.Ph | number : "1.2-2" }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{ opdata.Temp | number : "1.2-2" }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1ConcFlow | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1PermFlow | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1FeedPress | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1ConcPress | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1PermPress | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1FeedCond | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1PermCond | number : "1.2-2"
                  }}</a>
              </td>
            </tr>
          </tbody>

          <tbody [hidden]="stages2">
            <tr *ngFor="
                let opdata of opdataList
                  | paginate
                    : {
                        itemsPerPage: safePageSize(pageHeaders?.PageSize),
                        currentPage: safePageNumber(pageHeaders?.PageNumber),
                        totalItems: safeTotalItems(pageHeaders?.TotalItems)
                      }
              ">
              <td>
                <!-- <input
                  type="checkbox"
                  id="NouserSelected"
                  name="NouserSelected"
                  (change)="selectednoOtherUser(opdata.Id)"
                /> -->
                <input type="checkbox" class="custom-checkbox" [checked]="isRowSelected(opdata.Id)"
                  (change)="selectednoOtherUser(opdata.Id)" />
              </td>
              <td>
                <a class="text-black">{{
                  opdata.Datetime | date : "dd/MM/yyyy"
                  }}</a>
              </td>
              <td>
                <a class="text-black" (click)="navigate(opdata.Id)">{{
                  opdata.Datetime | date : "HH:mm:ss"
                  }}</a>
              </td>

              <td width="10%">
                <a class="text-black">{{ opdata.Ph | number : "1.2-2" }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{ opdata.Temp | number : "1.2-2" }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S2ConcFlow | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S2PermFlow | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S2FeedPress | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S2ConcPress | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S2PermPress | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S2FeedCond | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S2PermCond | number : "1.2-2"
                  }}</a>
              </td>
            </tr>
          </tbody>

          <tbody [hidden]="stages3">
            <tr *ngFor="
                let opdata of opdataList
                  | paginate
                    : {
                        itemsPerPage: safePageSize(pageHeaders?.PageSize),
                        currentPage: safePageNumber(pageHeaders?.PageNumber),
                        totalItems: safeTotalItems(pageHeaders?.TotalItems)
                      }
              ">
              <td>
                <!-- <input
                  type="checkbox"
                  id="NouserSelected"
                  name="NouserSelected"
                  (change)="selectednoOtherUser(opdata.Id)"
                /> -->
                <input type="checkbox" class="custom-checkbox" [checked]="isRowSelected(opdata.Id)"
                  (change)="selectednoOtherUser(opdata.Id)" />
              </td>
              <td>
                <a class="text-black" (click)="navigate(opdata.Id)">{{
                  opdata.Datetime | date : "dd/MM/yyyy"
                  }}</a>
              </td>
              <td>
                <a class="text-black">{{
                  opdata.Datetime | date : "HH:mm:ss"
                  }}</a>
              </td>

              <td width="10%">
                <a class="text-black">{{ opdata.Ph | number : "1.2-2" }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{ opdata.Temp | number : "1.2-2" }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S3ConcFlow | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S3PermFlow | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S3FeedPress | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S3ConcPress | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S3PermPress | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S3FeedCond | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S3PermCond | number : "1.2-2"
                  }}</a>
              </td>
            </tr>
          </tbody>

          <tbody [hidden]="total">
            <tr *ngFor="
                let opdata of opdataList
                  | paginate
                    : {
                        itemsPerPage: safePageSize(pageHeaders?.PageSize),
                        currentPage: safePageNumber(pageHeaders?.PageNumber),
                        totalItems: safeTotalItems(pageHeaders?.TotalItems)
                      }
              ">
              <td>
                <!-- <input
                  type="checkbox"
                  id="NouserSelected"
                  name="NouserSelected"
                  (change)="selectednoOtherUser(opdata.Id)"
                /> -->
                <input type="checkbox" class="custom-checkbox" [checked]="isRowSelected(opdata.Id)"
                  (change)="selectednoOtherUser(opdata.Id)" />
              </td>
              <td>
                <a class="text-black" (click)="navigate(opdata.Id)">{{
                  opdata.Datetime | date : "dd/MM/yyyy"
                  }}</a>
              </td>
              <td>
                <a class="text-black">{{
                  opdata.Datetime | date : "HH:mm:ss"
                  }}</a>
              </td>

              <td width="10%">
                <a class="text-black">{{ opdata.Ph | number : "1.2-2" }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{ opdata.Temp | number : "1.2-2" }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1ConcFlow | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1PermFlow | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1FeedPress | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1ConcPress | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1PermPress | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1FeedCond | number : "1.2-2"
                  }}</a>
              </td>
              <td width="10%">
                <a class="text-black">{{
                  opdata.S1PermCond | number : "1.2-2"
                  }}</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex bd-highlight">
          <div class="p-2 flex-grow-1 bd-highlight">
            Showing total

            {{ pageHeaders.TotalItems }} entries
          </div>
          <div class="p-2 bd-highlight" *ngIf="pageHeaders.TotalItems > 10">
            <pagination-controls (pageChange)="onPageChange($event)" class="my-pagination"></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>